import { Fonts } from './Ast';

export const DEFAULT = 'DEFAULT';
export const STYLISTIC = 'STYLISTIC';
export const REFACTOR = 'REFACTOR';
export const ADDITIVE = 'ADDITIVE';

export type PROMPT_TYPE = typeof DEFAULT | typeof STYLISTIC | typeof REFACTOR | typeof ADDITIVE;

export interface SandpackFile {
    code: string;
    hidden?: boolean;
    active?: boolean;
    readOnly?: boolean;
}

export interface BaseChatMessage {
    id: string;
    parentId: string | null;
    preferredChildId?: string;
    createDate: string;
    didError?: boolean;
}

export type SystemChatMessageContent =
    | SystemChatMessageContentCode
    | SystemChatMessageCheckbox
    | SystemChateMessageContentText;

export interface SystemChatMessageContentCode {
    type: 'code';
    fileName: string;
    content: string;
}

export interface SystemChatMessageCheckbox {
    type: 'checkbox';
    fileName: string;
    content: string;
}

interface SystemChateMessageContentText {
    type: 'text';
    content: string;
}

export interface SystemChatMessage extends BaseChatMessage {
    role: 'system';
    gptResponse: string;
    content: Array<SystemChatMessageContent>;
    files: Record<string, SandpackFile>;
}

export interface UserChatMessage extends BaseChatMessage {
    role: 'user';
    content: string;
    promptType: PROMPT_TYPE;
    parentId: string;
}

export type ChatMessage = SystemChatMessage | UserChatMessage;

export type ChatHistory = Record<string, ChatMessage>;

export interface AIHistory {
    id?: string;
    createdAt?: number;
    previewImage?: string;
    chat: ChatHistory;
    sourceDocId: string;
    userId: string;
    projectId: string;
    previewWidth: number;
}

export interface VersionUnit {
    id: string;

    prompt: string;
    status: 'loading' | 'success' | 'idle' | 'error';
    rating?: 'thumbsUp' | 'thumbsDown';

    rawCode: string;
    previewCode: string;
    previewCodeError?: string;
    parsedCode: string;

    parentPageId: string;
    gptOutput?: string;

    renditionExtraConfig?: {
        fonts?: Fonts;
    };

    // one day they should be used...
    createdBy: string;
    createdAt: number;

    // local only
    localOnlyState?: 'loading' | 'success';
}

export interface VersionGroup {
    id: string;
    versions: VersionUnit[];
    createdAt: number;

    // serverOnly
    selectedId: string;

    // localOnly:
    selectedVersion: VersionUnit;

    previousVersionId?: string;
}

export interface PageState {
    id: string;
    groupedVersions: Record<string, VersionGroup>;
    starredBy: string[];
    createdBy: string;
    createdAt: number;
    lastModified: number;
    mostRecentPreviewCode?: string;

    renditionExtraConfig?: {
        screenshotUrl: string;
        renditionCode: string;
        visionCode: string;
    };
}
